import script from "./LayoutAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&setup=true&lang=js"

import "./LayoutAuth.vue?vue&type=style&index=0&id=4d55fe32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d55fe32"]])

export default __exports__